import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["foldersOnly", "foldersWithFiles"]

  toggleFoldersOnly(event) {
    if (event.target.checked) {
      this.foldersWithFilesTarget.checked = false
    }
  }

  toggleFoldersWithFiles(event) {
    if (event.target.checked) {
      this.foldersOnlyTarget.checked = false
    }
  }
}
